import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

export const BrandAppliedBadge = () => {
  const [profile, setProfile] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/profile/business`, {
      headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` },
    })
      .then((r) => r.json())
      .then(setProfile)
      .catch(() => {});
  }, []);

  if (!profile || (!profile.company_name && !profile.logo_url)) {
    return (
      <div className="flex items-center gap-2 mb-6 text-sm" data-testid="brand-not-set-badge">
        <span className="text-gray">Assets show [Company], [Phone] placeholders —</span>
        <Link to="/my-brand" className="text-orange font-bold hover:underline">set up My Brand once and it fills in everywhere →</Link>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3 mb-6 px-4 py-2.5 rounded-lg bg-lime/5 border border-lime/25 w-fit" data-testid="brand-applied-badge">
      {profile.logo_url && (
        <img src={profile.logo_url} alt="logo" className="w-8 h-8 rounded object-contain bg-black" />
      )}
      <CheckCircle2 size={16} className="text-lime shrink-0" />
      <p className="text-sm text-light-gray">
        <span className="text-white font-bold">{profile.company_name}</span>
        {profile.phone ? ` · ${profile.phone}` : ''} — your branding is applied to every asset in this campaign.
        <Link to="/my-brand" className="text-orange hover:underline ml-1">Edit</Link>
      </p>
    </div>
  );
};
